<div class="switch-container" (click)="toggleSwitch($event)">
  <div class="switch-option" [class.active]="activeOption === 1">
    Заклади за напрямом
  </div>
  <div class="switch-option" [class.active]="activeOption === 2">
    Всi заклади
  </div>
</div>
